const BLUR_THRESHOLD = 50 as const;
const DARKNESS_THRESHOLD = 60 as const;
const SHADOW_THRESHOLD = 0.15 as const;
const BOUNDARY_MARGIN = 0 as const;
const BACKGROUND_THRESHOLD = 0.7 as const;
const BACKGROUND_MAX_OBSTRUCTION_RATIO = 0.15 as const;
const BACKGROUND_IGNORE_STICKY_NOTES = true as const;
const REMOVE_BACKGROUND_MIN_AREA_RATIO = 0.05 as const;

export type ImageQualityCheckResult = {
  overall: boolean;
  boundary: boolean;
  background: boolean;
  shadow: boolean;
  blur: boolean;
  darkness: boolean;
};

export async function imageQualityCheck(file: File): Promise<ImageQualityCheckResult> {
  const url = URL.createObjectURL(file);
  try {
    const { checkQuality } = await import('@axa-japan/sharp-doc-js');
    const report = await checkQuality(url, {
      blur: { enabled: true, threshold: BLUR_THRESHOLD },
      darkness: { enabled: true, threshold: DARKNESS_THRESHOLD },
      shadow: { enabled: true, threshold: SHADOW_THRESHOLD },
      boundary: { enabled: true, margin: BOUNDARY_MARGIN },
      background: {
        enabled: true,
        threshold: BACKGROUND_THRESHOLD,
        maxObstructionRatio: BACKGROUND_MAX_OBSTRUCTION_RATIO,
        ignoreStickyNotes: BACKGROUND_IGNORE_STICKY_NOTES,
      },
      removeBackground: {
        enabled: true,
        minAreaRatio: REMOVE_BACKGROUND_MIN_AREA_RATIO,
      },
    });
    return {
      overall: report.overall,
      boundary: report.checks.boundary.passed,
      background: report.checks.background.passed,
      shadow: report.checks.shadow.passed,
      blur: report.checks.blur.passed,
      darkness: report.checks.darkness.passed,
    };
  } finally {
    URL.revokeObjectURL(url);
  }
}
